import React from "react";

import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";

import RangePicker from "@cloudscape-design/components/date-range-picker";
import Alert from "@cloudscape-design/components/alert";
import Table from "@cloudscape-design/components/table";
import Box from "@cloudscape-design/components/box";
import Header from "@cloudscape-design/components/header";
import LineChart from "@cloudscape-design/components/line-chart";
import Container from "@cloudscape-design/components/container";
import Grid from "@cloudscape-design/components/grid";
import Tabs from "@cloudscape-design/components/tabs";
import Select from "@cloudscape-design/components/select";
import Button from "@cloudscape-design/components/button";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { pstatStore } from "../stores/pstats";
/* ------- */

class Stats extends React.Component {
	constructor(props) {
		super(props);
		this.rawData = [];
	}

	componentDidMount() {
		this.props.Interface.isPaymentDataLoaded().then(() => {
			let currentPeriod = this.props.config.pstats.options.period[4].type;

			if (this.props.config.pstats.options.payway.length)
				setTimeout(() => {
					this.props.setPStats({
						...this.props.pstats,
						loaded: false,
						data: [],
						limit: currentPeriod.limit,
						offset: currentPeriod.offset,
						range: { type: "absolute", startDate: this.formatLimitOffset(currentPeriod.limit, currentPeriod.offset).from, endDate: this.formatLimitOffset(this.props.pstats.limit, this.props.pstats.offset).to },
						currentPayWay: this.props.config.pstats.options.payway[0].type,
						currentGroup: this.props.config.pstats.options.delimiter[0].type,
						currentOption: { ...this.props.pstats.currentOption, group: this.props.config.pstats.options.delimiter[0], period: this.props.config.pstats.options.period[4], payWay: this.props.config.pstats.options.payway[0] },
					});
				}, 0);
			else
				setTimeout(() => {
					this.props.setPStats({
						...this.props.pstats,
						loaded: false,
						data: [],
						limit: currentPeriod.limit,
						offset: currentPeriod.offset,
						range: { type: "absolute", startDate: this.formatLimitOffset(currentPeriod.limit, currentPeriod.offset).from, endDate: this.formatLimitOffset(this.props.pstats.limit, this.props.pstats.offset).to },
						currentGroup: this.props.config.pstats.options.delimiter[0].type,
						currentOption: { ...this.props.pstats.currentOption, group: this.props.config.pstats.options.delimiter[0], period: this.props.config.pstats.options.period[4] },
					});
				}, 0);

			setTimeout(() => {
				this.loadStats();
			}, 100);
		});
	}

	componentWillUnmount() {
		this.props.setPStats({ ...this.props.pstats, loaded: false, data: [] });
	}

	saveData(data) {
		const element = document.createElement("a");
		const file = new Blob([JSON.stringify(data)], {
			type: "text/plain",
		});
		element.href = URL.createObjectURL(file);
		element.download = this.props.config.app.name.toLowerCase() + "_pstats_" + +new Date() + ".json";
		document.body.appendChild(element);
		element.click();
	}

	loadStats() {
		if (this.props.pstats.limit) {
			this.props.setPStats({ ...this.props.pstats, loaded: false, data: [] });

			this.props.Interface.request("get", { class: "data", module: "info", method: "pStats" }, { offset: this.props.pstats.offset, limit: this.props.pstats.limit, payWay: this.props.pstats.currentPayWay || "all" })
				.then((rawData) => {
					this.rawData = rawData;
					this.rebuildStats();
				})
				.catch((e) => {
					this.props.setPStats({ ...this.props.pstats, data: [], chart: { deposits: { total: [], count: [], first: [] }, withdrawals: { total: [], count: [] }, profit: [], players: [] }, loaded: true, error: e });
				});
		}
	}

	rebuildStats() {
		let total = 0,
			average = 0,
			chart = { deposits: { total: [], count: [], first: [] }, withdrawals: { total: [], count: [] }, profit: [], players: [] },
			totalColumn = { profit: 0, average_percent: 0, deposits: { total: 0, count: 0, first: 0 }, withdrawals: { total: 0, count: 0 }, players: 0 };
		let data = [],
			j = 0;

		let rawData = this.rawData;

		rawData.reverse().forEach((stat, i) => {
			if (i && i % this.props.pstats.currentGroup === 0) j++;

			if (typeof data[j] === "undefined") data[j] = { deposits: { total: 0, count: 0, first: 0 }, withdrawals: { total: 0, count: 0 }, days: 0, profit: 0, date: stat.date, players: 0 };

			data[j].days++;
			data[j].deposits.total += stat.deposits.total;
			data[j].deposits.count += stat.deposits.count;
			data[j].deposits.first += stat.deposits.first;
			data[j].withdrawals.total += stat.withdrawals.total;
			data[j].withdrawals.count += stat.withdrawals.count;
			data[j].profit += stat.deposits.total - stat.withdrawals.total;
			data[j].dateEnd = stat.date;
			data[j].players += stat.players;
		});

		data.forEach((stat) => {
			total += stat.deposits.total;
			total -= stat.withdrawals.total;
			stat.profit = stat.deposits.total - stat.withdrawals.total;

			totalColumn.deposits.total += stat.deposits.total;
			totalColumn.deposits.count += stat.deposits.count;
			totalColumn.deposits.first += stat.deposits.first;
			totalColumn.withdrawals.total += stat.withdrawals.total;
			totalColumn.withdrawals.count += stat.withdrawals.count;

			totalColumn.profit += stat.profit;
			totalColumn.players += stat.players;
			chart.deposits.total.push({ x: typeof stat.dateEnd === "undefined" || stat.date === stat.dateEnd ? new Date(stat.date).toLocaleDateString() : new Date(stat.date).toLocaleDateString().split("/").slice(0, -1).join("/") + " - " + new Date(stat.dateEnd).toLocaleDateString().split("/").slice(0, -1).join("/"), y: stat.deposits.total });
			chart.deposits.count.push({ x: typeof stat.dateEnd === "undefined" || stat.date === stat.dateEnd ? new Date(stat.date).toLocaleDateString() : new Date(stat.date).toLocaleDateString().split("/").slice(0, -1).join("/") + " - " + new Date(stat.dateEnd).toLocaleDateString().split("/").slice(0, -1).join("/"), y: stat.deposits.count });
			chart.deposits.first.push({ x: typeof stat.dateEnd === "undefined" || stat.date === stat.dateEnd ? new Date(stat.date).toLocaleDateString() : new Date(stat.date).toLocaleDateString().split("/").slice(0, -1).join("/") + " - " + new Date(stat.dateEnd).toLocaleDateString().split("/").slice(0, -1).join("/"), y: stat.deposits.first });

			chart.withdrawals.total.push({ x: typeof stat.dateEnd === "undefined" || stat.date === stat.dateEnd ? new Date(stat.date).toLocaleDateString() : new Date(stat.date).toLocaleDateString().split("/").slice(0, -1).join("/") + " - " + new Date(stat.dateEnd).toLocaleDateString().split("/").slice(0, -1).join("/"), y: stat.withdrawals.total });
			chart.withdrawals.count.push({ x: typeof stat.dateEnd === "undefined" || stat.date === stat.dateEnd ? new Date(stat.date).toLocaleDateString() : new Date(stat.date).toLocaleDateString().split("/").slice(0, -1).join("/") + " - " + new Date(stat.dateEnd).toLocaleDateString().split("/").slice(0, -1).join("/"), y: stat.withdrawals.count });

			chart.players.push({ x: typeof stat.dateEnd === "undefined" || stat.date === stat.dateEnd ? new Date(stat.date).toLocaleDateString() : new Date(stat.date).toLocaleDateString().split("/").slice(0, -1).join("/") + " - " + new Date(stat.dateEnd).toLocaleDateString().split("/").slice(0, -1).join("/"), y: stat.players });

			chart.profit.push({ x: typeof stat.dateEnd === "undefined" || stat.date === stat.dateEnd ? new Date(stat.date).toLocaleDateString() : new Date(stat.date).toLocaleDateString().split("/").slice(0, -1).join("/") + " - " + new Date(stat.dateEnd).toLocaleDateString().split("/").slice(0, -1).join("/"), y: stat.profit });
		});

		average = parseFloat(total / data.length);

		data.forEach((stat) => {
			stat.average_percent = parseFloat((-100 + (stat.profit / average) * 100).toFixed(2));
			if (isNaN(stat.average_percent)) stat.average_percent = 0;
		});

		totalColumn.date = "Total";

		data.reverse().push(totalColumn);
		this.rawData.reverse();

		this.props.setPStats({ ...this.props.pstats, data, chart, average, total, loaded: true });
	}

	compare(a, b) {
		if (this.props.pstats.sorting.sortingColumn.sortingField.indexOf(".") === -1) {
			if (a[this.props.pstats.sorting.sortingColumn.sortingField] < b[this.props.pstats.sorting.sortingColumn.sortingField]) {
				return this.props.pstats.sorting.isDescending ? 1 : -1;
			}

			if (a[this.props.pstats.sorting.sortingColumn.sortingField] > b[this.props.pstats.sorting.sortingColumn.sortingField]) {
				return this.props.pstats.sorting.isDescending ? -1 : 1;
			}
		} else {
			if (a[this.props.pstats.sorting.sortingColumn.sortingField.split(".")[0]][this.props.pstats.sorting.sortingColumn.sortingField.split(".")[1]] < b[this.props.pstats.sorting.sortingColumn.sortingField.split(".")[0]][this.props.pstats.sorting.sortingColumn.sortingField.split(".")[1]]) {
				return this.props.pstats.sorting.isDescending ? 1 : -1;
			}

			if (a[this.props.pstats.sorting.sortingColumn.sortingField.split(".")[0]][this.props.pstats.sorting.sortingColumn.sortingField.split(".")[1]] > b[this.props.pstats.sorting.sortingColumn.sortingField.split(".")[0]][this.props.pstats.sorting.sortingColumn.sortingField.split(".")[1]]) {
				return this.props.pstats.sorting.isDescending ? -1 : 1;
			}
		}

		return 0;
	}

	formatRange(startDate, stopDate) {
		startDate = startDate.split("-").join("/");
		stopDate = stopDate.split("-").join("/");

		let limit = 0,
			offset = [],
			currentDate = +new Date(startDate);

		while (currentDate <= +new Date(stopDate)) {
			currentDate = +new Date(currentDate).setDate(new Date(currentDate).getDate() + 1);
			limit++;
		}

		offset = (+new Date(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate()) - +new Date(stopDate)) / 1000 / 60 / 60 / 24;
		return { limit, offset };
	}

	formatLimitOffset(limit, offset) {
		let startDate = +new Date().setDate(new Date().getDate() - offset),
			endDate = +new Date().setDate(new Date().getDate() - offset - limit + 1);
		return { from: new Date(endDate).toLocaleDateString().split("/").reverse().join("-"), to: new Date(startDate).toLocaleDateString().split("/").reverse().join("-") };
	}

	render() {
		return (
			<>
				{this.props.pstats.loaded && !this.props.pstats.data.length && this.props.pstats.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.pstats.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.pstats.error.code} | request timestamp: {this.props.pstats.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Container
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="New players financial stats"
									counter={<>({this.props.pstats.data.length ? this.props.pstats.data.length - 1 : 0})</>}
									actions={
										<Button
											disabled={!this.props.pstats.loaded || !this.props.pstats.data.length}
											className={this.props.styles["players-search-button"]}
											onClick={() => {
												this.saveData(this.props.pstats.data);
											}}
											variant="primary"
											children="Export"
										/>
									}
									description="Below listed stats for selected date"
								/>
							}
						/>
					}
					children={
						<>
							<Grid
								gridDefinition={[{ colspan: 12 }, { colspan: 4 }, { colspan: 4 }, { colspan: 4 }]}
								children={
									<>
										<RangePicker
											disabled={!this.props.pstats.loaded}
											relativeOptions={[]}
											clearButtonLabel="Clear"
											dateOnly={true}
											placeholder="Select range for show stats"
											onChange={(range) => {
												this.props.setPStats({ ...this.props.pstats, ...this.formatRange(range.detail.value.startDate, range.detail.value.endDate), range: range.detail.value });
												setTimeout(() => {
													this.loadStats();
												}, 250);
											}}
											value={this.props.pstats.range}
											i18nStrings={{
												customRelativeRangeUnitLabel: "",
												formatRelativeRange: (value) => {
													return value.amount;
												},
												formatUnit: () => {
													return "";
												},
												nextMonthAriaLabel: "Next",
												applyButtonLabel: "Ok",
											}}
										/>
										<Select
											filteringType="auto"
											disabled={!this.props.pstats.loaded}
											placeholder="Group by"
											selectedOption={this.props.pstats.currentOption.group}
											onChange={(option) => {
												option.detail.selectedOption.type !== this.props.pstats.currentGroup && this.props.setPStats({ ...this.props.pstats, currentGroup: option.detail.selectedOption.type, currentOption: { ...this.props.pstats.currentOption, group: option.detail.selectedOption } });
												setTimeout(() => {
													this.rebuildStats();
												}, 0);
											}}
											options={this.props.config.pstats.options.delimiter}
										/>

										<Select
											filteringType="auto"
											disabled={!this.props.pstats.loaded}
											placeholder="Payway"
											selectedOption={this.props.pstats.currentOption.payWay}
											onChange={(option) => {
												option.detail.selectedOption.type !== this.props.pstats.currentPayWay && this.props.setPStats({ ...this.props.pstats, currentPayWay: option.detail.selectedOption.type, currentOption: { ...this.props.pstats.currentOption, payWay: option.detail.selectedOption } });
												setTimeout(() => {
													this.loadStats();
												}, 0);
											}}
											options={this.props.config.pstats.options.payway}
										/>

										<Select
											filteringType="auto"
											disabled={!this.props.pstats.loaded}
											placeholder="Period"
											selectedOption={this.props.pstats.currentOption.period}
											onChange={(option) => {
												!isEqual(option.detail.selectedOption.type, this.props.pstats.currentPeriod) &&
													this.props.setPStats({
														...this.props.pstats,
														currentPeriod: option.detail.selectedOption.type,
														currentOption: { ...this.props.pstats.currentOption, period: option.detail.selectedOption },
														limit: option.detail.selectedOption.type.limit,
														offset: option.detail.selectedOption.type.offset,
														range: { type: "absolute", startDate: this.formatLimitOffset(option.detail.selectedOption.type.limit, option.detail.selectedOption.type.offset).from, endDate: this.formatLimitOffset(option.detail.selectedOption.type.limit, option.detail.selectedOption.type.offset).to },
													});
												setTimeout(() => {
													this.loadStats();
												}, 0);
											}}
											options={this.props.config.pstats.options.period}
										/>
									</>
								}
							/>
							<Tabs
								tabs={[
									{
										id: "table",
										label: "Table view",
										content: (
											<Table
												stickyHeader={true}
												loading={!this.props.pstats.loaded}
												sortingColumn={{ sortingField: this.props.pstats.sorting.sortingColumn.sortingField }}
												sortingDescending={this.props.pstats.sorting.isDescending}
												onSortingChange={(sorting) => {
													this.props.setPStats({ ...this.props.pstats, sorting: sorting.detail });
													setTimeout(() => {
														this.props.setPStats({
															...this.props.pstats,
															data: cloneDeep(this.props.pstats.data).sort((a, b) => {
																return this.compare(a, b);
															}),
														});
													}, 0);
												}}
												columnDefinitions={[
													{ header: "Date", sortingField: "date", cell: (item) => (typeof item.date === "string" ? <b>{item.date}</b> : typeof item.dateEnd !== "undefined" && item.date !== item.dateEnd ? new Date(item.date).toLocaleDateString() + " - " + new Date(item.dateEnd).toLocaleDateString() : new Date(item.date).toLocaleDateString()) },
													{ id: "players", header: "Registrations", sortingField: "players", cell: (item) => item.players },
													{ id: "profit", header: "Profit", sortingField: "profit", cell: (item) => <Box variant="span" color={item.profit >= 0 ? (item.profit > 0 ? "text-status-success" : "text-body-secondary") : "text-status-error"} children={<>{new Intl.NumberFormat("ru-RU").format(item.profit)} RUB.</>} /> },
													{ id: "depositsTotal", header: "Deposits amount", sortingField: "deposits.total", cell: (item) => new Intl.NumberFormat("ru-RU").format(item.deposits.total) + " RUB." },
													{ id: "withdrawalsTotal", header: "Withdrawals amount", sortingField: "withdrawals.total", cell: (item) => new Intl.NumberFormat("ru-RU").format(item.withdrawals.total) + " RUB." },
													{ id: "depositsCount", header: "Deposits count", sortingField: "deposits.count", cell: (item) => item.deposits.count },
													{ id: "depositsFirst", header: "First deposits", sortingField: "deposits.first", cell: (item) => item.deposits.first },
													{ id: "withdrawalsCount", header: "Withdrawals count", sortingField: "withdrawals.count", cell: (item) => item.withdrawals.count },
													{ header: "Average profit", sortingField: "average_percent", cell: (item) => <Box variant="span" color={item.average_percent > -20 ? (item.average_percent > 0 ? "text-status-success" : "text-body-secondary") : "text-status-error"} children={item.average_percent + "%"} /> },
												]}
												empty="No stats was loaded"
												items={this.props.pstats.data}
											/>
										),
									},
									{
										id: "chart",
										label: "Chart view",
										content: (
											<Grid
												gridDefinition={[{ colspan: 12 }, { colspan: 12 }, { colspan: 12 }, { colspan: 12 }]}
												children={
													<>
														<Grid
															gridDefinition={[{ colspan: { default: 12, m: 6 } }, { colspan: { default: 12, m: 6 } }]}
															children={
																<>
																	<Container
																		header={<Header children={"Deposits total chart (" + (this.props.pstats.data.length ? new Intl.NumberFormat("ru-RU").format(this.props.pstats.data[this.props.pstats.data.length - 1].deposits.total) : 0) + " RUB.)"} />}
																		children={<LineChart hideLegend={true} hideFilter={true} statusType={this.props.pstats.loaded && typeof this.props.pstats.chart.deposits !== "undefined" ? "finished" : "loading"} yScaleType="linear" xScaleType="categorical" series={[{ title: "Deposits total", type: "bar", data: this.props.pstats.chart.deposits.total }]} errorText="Error building chart" />}
																	/>
																	<Container
																		header={<Header children={"Deposits count chart (" + (this.props.pstats.data.length ? this.props.pstats.data[this.props.pstats.data.length - 1].deposits.count : 0) + ")"} />}
																		children={<LineChart hideLegend={true} hideFilter={true} statusType={this.props.pstats.loaded && typeof this.props.pstats.chart.deposits !== "undefined" ? "finished" : "loading"} yScaleType="linear" xScaleType="categorical" series={[{ title: "Deposits count", color: "#1f8205", type: "line", data: this.props.pstats.chart.deposits.count }]} errorText="Error building chart" />}
																	/>
																</>
															}
														/>

														<Grid
															gridDefinition={[{ colspan: { default: 12, m: 6 } }, { colspan: { default: 12, m: 6 } }]}
															children={
																<>
																	<Container
																		header={<Header children={"Profit chart (" + (this.props.pstats.data.length ? new Intl.NumberFormat("ru-RU").format(this.props.pstats.data[this.props.pstats.data.length - 1].profit) : 0) + " RUB.)"} />}
																		children={<LineChart hideLegend={true} hideFilter={true} statusType={this.props.pstats.loaded && typeof this.props.pstats.chart.profit !== "undefined" ? "finished" : "loading"} yScaleType="linear" xScaleType="categorical" series={[{ title: "Profit chart", color: "#f59300", type: "bar", data: this.props.pstats.chart.profit }]} errorText="Error building chart" />}
																	/>
																	<Container
																		header={<Header children={"Players registrations chart (" + (this.props.pstats.data.length ? this.props.pstats.data[this.props.pstats.data.length - 1].players : 0) + ")"} />}
																		children={<LineChart hideLegend={true} hideFilter={true} statusType={this.props.pstats.loaded && typeof this.props.pstats.chart.deposits !== "undefined" ? "finished" : "loading"} yScaleType="linear" xScaleType="categorical" series={[{ title: "Players registrations", color: "#1f8205", type: "line", data: this.props.pstats.chart.players }]} errorText="Error building chart" />}
																	/>
																</>
															}
														/>

														<Grid
															gridDefinition={[{ colspan: { default: 12, m: 6 } }, { colspan: { default: 12, m: 6 } }]}
															children={
																<>
																	<Container
																		header={<Header children={"Withdrawals total chart (" + (this.props.pstats.data.length ? new Intl.NumberFormat("ru-RU").format(this.props.pstats.data[this.props.pstats.data.length - 1].withdrawals.total) : 0) + " RUB.)"} />}
																		children={<LineChart hideLegend={true} hideFilter={true} statusType={this.props.pstats.loaded && typeof this.props.pstats.chart.withdrawals !== "undefined" ? "finished" : "loading"} yScaleType="linear" xScaleType="categorical" series={[{ title: "Withdrawals total", type: "bar", data: this.props.pstats.chart.withdrawals.total }]} errorText="Error building chart" />}
																	/>
																	<Container
																		header={<Header children={"Withdrawals count chart (" + (this.props.pstats.data.length ? this.props.pstats.data[this.props.pstats.data.length - 1].withdrawals.count : 0) + ")"} />}
																		children={<LineChart hideLegend={true} hideFilter={true} statusType={this.props.pstats.loaded && typeof this.props.pstats.chart.withdrawals !== "undefined" ? "finished" : "loading"} yScaleType="linear" xScaleType="categorical" series={[{ title: "Withdrawals count", color: "#1f8205", type: "line", data: this.props.pstats.chart.withdrawals.count }]} errorText="Error building chart" />}
																	/>
																</>
															}
														/>

														<Grid
															gridDefinition={[{ colspan: 12 }]}
															children={
																<>
																	<Container
																		header={<Header children={"First deposits chart (" + (this.props.pstats.data.length ? this.props.pstats.data[this.props.pstats.data.length - 1].deposits.first : 0) + ")"} />}
																		children={<LineChart hideLegend={true} hideFilter={true} statusType={this.props.pstats.loaded && typeof this.props.pstats.chart.deposits !== "undefined" ? "finished" : "loading"} yScaleType="linear" xScaleType="categorical" series={[{ title: "First deposits", color: "#1f8205", type: "line", data: this.props.pstats.chart.deposits.first }]} errorText="Error building chart" />}
																	/>
																</>
															}
														/>
													</>
												}
											/>
										),
									},
								]}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const pstats = useRecoilValue(pstatStore);
		const setPStats = useSetRecoilState(pstatStore);
		const config = useRecoilValue(configStore);

		return <Component {...props} pstats={pstats} setPStats={setPStats} config={config} />;
	};
}

export default withRecoil(Stats);
